
import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../api/api";
 
const AuthContext = createContext();
 
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Initialize auth state from localStorage
  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user");
    if (token && storedUser) {
      setUser(JSON.parse(storedUser));
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    setLoading(false);
  }, []);
  
  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      setUser(data.user);
      console.log(data);
      api.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
    } catch (err) {
      console.error("Login failed:", err);
      if (err.response?.data?.message) {
        throw new Error(err.response.data.message);
      } else {
        throw new Error("Login failed. Please try again.");
      }
    }
  };
  
  const logout = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        await api.post("/auth/logout", {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } catch (err) {
        console.log("Logout API error:", err);
      }
    }
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("salesDashboardFilters");
    sessionStorage.removeItem("salesDashboardReload");
    delete api.defaults.headers.common["Authorization"];
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
 
export const useAuth = () => useContext(AuthContext);
